// In docker containers we generate a js file from the config that gets inserted into the index.html
const ENV = window.ENV ? window.ENV : process.env;

export const API_URL = ENV.REACT_APP_API_URL;
export const BFF_API_ROOT_URL = ENV.REACT_APP_BFF_API_ROOT_URL;
export const SUBSCRIPTION_KEY = ENV.REACT_APP_SUBSCRIPTION_KEY;
export const APP_ENVIRONMENT = ENV.REACT_APP_ENVIRONMENT;
export const NOTIFICATIONS_RETENTION_TIME = ENV.REACT_APP_NOTIFICATIONS_RETENTION_TIME;
export const EXTERNALPRODUCTPAGE = ENV.REACT_APP_EXTERNALPRODUCTPAGE;
export const USERISEXPIRING_WARNING_INMINUTES = ENV.REACT_APP_USERISEXPIRING_WARNING_INMINUTES;
export const USE_BETA_SCREENS = ENV.REACT_APP_USE_BETA_SCREENS;
export const TERMINAL_OVERRULEMAXITEMS = ENV.REACT_APP_TERMINAL_OVERRULEMAXITEMS;
export const ALFAPASS_AUTHORIZE_ENDPOINT = ENV.REACT_APP_ALFAPASS_AUTHORIZE_ENDPOINT;
export const ALFAPASS_TOKEN_ENDPOINT = ENV.REACT_APP_ALFAPASS_TOKEN_ENDPOINT;
export const ALFAPASS_CALLBACK_ENDPOINT = ENV.REACT_APP_ALFAPASS_CALLBACK_ENDPOINT;
export const TERMS_AND_CONDITIONS_VERSION = ENV.REACT_APP_TERMS_AND_CONDITIONS_VERSION;
export const B2C_CLIENT_ID = ENV.REACT_APP_B2C_CLIENT_ID;
export const B2C_AUTHORITY_URL = ENV.REACT_APP_B2C_AUTHORITY_URL;
export const B2C_KNOWN_AUTHORITY = ENV.REACT_APP_B2C_KNOWN_AUTHORITY;
export const B2C_SCOPE = ENV.REACT_APP_B2C_SCOPE;
export const B2C_ERROR_BACKGROUND = ENV.REACT_APP_B2C_ERROR_BACKGROUND;
